import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import YellowGreenButton from './YellowGreenButton';
import i18n from '../utils/i18n';
import SlotInfo from './SlotInfo';
import {
  disableBookStatuses,
  bookingAvailabilityStatusesMessages
} from '../utils/constants';
import './styles/SessionCardComponent.scss';

const SessionCardComponent = ({
  picture,
  time,
  name,
  subname,
  address,
  goToSession,
  venueClubName,
  startQuickBooking,
  greyOut,
  pendingBooking,
  bookingAvailabilityStatus
}) => {
  const buttonDisabled =
    disableBookStatuses.indexOf(bookingAvailabilityStatus) !== -1;
  const buttonText = buttonDisabled
    ? bookingAvailabilityStatusesMessages[bookingAvailabilityStatus]
    : i18n.t('sessionsScreen.BOOK_SLOT');
  return (
    <div
      className={ `session-card-component ${greyOut &&
        'session-card-component-grey-out'} ${pendingBooking &&
        'session-card-pending-booking'}` }
    >
      <div className="session-card">
        <div className="card-component__upper-event">
          <img
            className="card-component__upper-photo"
            alt=""
            src={ picture && decodeURIComponent(picture) }
          />
        </div>
        <div className="book-button-wrapper">
          <YellowGreenButton
            text={ buttonText }
            style={ {
              width: '200px'
            } }
            onClick={ buttonDisabled ? () => {} : startQuickBooking }
            buttonClass={ buttonDisabled ? 'disabled-book-button' : '' }
          />
        </div>
        <div className="lower-session-info">
          <div className="session-details" onClick={ goToSession }>
            <div className="name">
              {name}
            </div>
            <div className="subname">
              {subname}
            </div>
          </div>
          <hr />
          <SlotInfo date={ time } clubName={ venueClubName } address={ address } />
          <div
            className="bottom-card-text more-dates-and-locations"
            onClick={ goToSession }
          >
            {i18n.t('sessionsScreen.MORE_DATES_AND_LOCATIONS')}
            <FontAwesome className="arrow-right" name="arrow-right" />
          </div>
        </div>
      </div>
    </div>
  );
};

SessionCardComponent.propTypes = {
  picture: PropTypes.string,
  time: PropTypes.string,
  name: PropTypes.string,
  subname: PropTypes.string,
  address: PropTypes.string,
  goToSession: PropTypes.func,
  venueClubName: PropTypes.string,
  startQuickBooking: PropTypes.func,
  greyOut: PropTypes.bool,
  pendingBooking: PropTypes.bool,
  bookingAvailabilityStatus: PropTypes.string
};

SessionCardComponent.defaultProps = {
  picture: '',
  time: '',
  name: '',
  subname: '',
  address: '',
  goToSession: () => {},
  venueClubName: '',
  startQuickBooking: () => {},
  greyOut: false,
  pendingBooking: false,
  bookingAvailabilityStatus: ''
};

export default SessionCardComponent;



// WEBPACK FOOTER //
// ./src/components/SessionCardComponent.js